import axios from "axios";
import { keycloak } from "../providers/AuthProvider";

const { REACT_APP_SERVER_URL } = process.env;

// Step-1: Create a new Axios instance with a custom config.
// The timeout is set to 10s. If the request takes longer than
// that then the request will be aborted.
const api = axios.create({
  baseURL: REACT_APP_SERVER_URL,
  timeout: 10000,
});

// Add interceptor to inject and refresh token
api.interceptors.request.use(
  async (config) => {
    try {
      // Refresh token if it's expiring within 30 seconds
      await keycloak.updateToken(30);
      // Save token to localStorage
      localStorage.setItem("keycloak.token", keycloak.token);
      config.headers = {
        Authorization: `Bearer ${keycloak.token}`,
      };

    } catch (error) {
      console.error("Failed to refresh Keycloak token", error);
      keycloak.logout();
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
